<wchfs-icon svgIcon="pso:sound_1_m" color="supporting-3" size="24" *ngIf="NoiseClass.firstClass(noise)"></wchfs-icon>
<wchfs-icon svgIcon="pso:sound_2_m" color="supporting-3" size="24" *ngIf="NoiseClass.secondClass(noise)"></wchfs-icon>
<wchfs-icon svgIcon="pso:sound_m" color="supporting-3" size="24" *ngIf="NoiseClass.thirdClass(noise)"></wchfs-icon>

<span class="noise" *ngIf="noise">{{ noise }} </span> &nbsp;
<span class="name" *ngIf="noiseLevel"> ({{ noiseLevel }}{{ 'db_unit' | translate }})</span>
